import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Common/Home'
import AddArtefact from '@/components/Presentation/Artefacts/AddArtefact'
import Artefacts from '@/components/Common/Artefacts'
import ArtefactSingle from '@/components/Common/ArtefactSingle'
import Messaging from '@/components/Administration/Messaging'
import Settings from '@/components/Administration/Settings'
import Users from '@/components/Administration/Users'
import Tasks from '@/components/Administration/Tasks'
import Collections from '@/components/Common/Collections'
import CollectionSingle from '@/components/Common/CollectionSingle'
import ManageCollections from '@/components/Administration/Collections/ManageCollections'
import ManageGroups from '@/components/Administration/Groups/ManageGroups'
import EditArtefact from '@/components/Common/EditArtefact'
import Explore from '@/components/Common/Explore'
import GroupSingle from '@/components/Common/GroupSingle'
import LogIn from '@/components/Common/LogIn'
import Reset from '@/components/Common/Reset'
import MyAccount from '@/components/Presentation/User/MyAccount'
import SignUp from '@/components/Presentation/User/SignUp'
import Groups from '@/components/Common/Groups'
import TermsAndConditions from '@/components/Common/TermsAndConditions'
import About from '@/components/Common/About'
import Contact from '@/components/Common/Contact'
import Links from '@/components/Common/Links'
import NotFound from '@/components/Common/NotFound'
import Meta from 'vue-meta'

Vue.use(Router)
Vue.use(Meta)

export default new Router({
  routes: [
    { path: '/sitemaps.xml', alias: '/api/sitemaps.xml' },
    {
      path: '/',
      name: '@Common/Home.vue',
      component: Home
    },
    {
      path: '/explore',
      name: '@Common/Explore.vue',
      component: Explore
    },
    {
      path: '/artefacts',
      name: '@Common/Artefacts.vue',
      component: Artefacts
    },
    {
      path: '/group-collections',
      name: '@Common/Groups.vue',
      component: Groups
    },
    {
      path: '/artefacts/new',
      name: '@Presentation/Artefacts/AddArtefact',
      component: AddArtefact
    },
    {
      path: '/artefacts/:id',
      props: true,
      name: '@Common/ArtefactSingle.vue',
      component: ArtefactSingle
    },
    {
      path: '/collections/new',
      name: '@Administration/Collections/ManageCollections.vue',
      component: ManageCollections

    },
    {
      path: '/collections/:id',
      props: true,
      name: '@Common/CollectionSingle.vue',
      component: CollectionSingle
    },
    {
      path: '/collections/',
      name: '@Common/Collections.vue',
      component: Collections
    },
    {
      path: '/account/',
      name: '@Common/Presentation/User/MyAccount.vue',
      component: MyAccount
    },
    {
      path: '/signup/',
      name: '@Common/Presentation/User/SignUp.vue',
      component: SignUp
    },
    {
      path: '/users',
      name: '@Administration/Users.vue',
      component: Users
    },
    {
      path: '/messaging',
      name: '@Administration/Messaging.vue',
      component: Messaging
    },
    {
      path: '/settings',
      name: '@Administration/Settings.vue',
      component: Settings
    },
    {
      path: '/groups/new',
      name: '@Administration/Groups/ManageGroups.vue',
      component: ManageGroups
    },
    {
      path: '/artefacts/edit/:id',
      props: true,
      name: '@Common/EditArtefact.vue',
      component: EditArtefact
    },
    {
      path: '/groups/:id',
      props: true,
      name: '@Common/GroupSingle.vue',
      component: GroupSingle
    },
    {
      path: '/reset/:token',
      props: true,
      name: '@Common/Reset.vue',
      component: Reset
    },
    {
      path: '/signin',
      name: '@Common/LogIn.vue',
      component: LogIn
    },
    {
      path: '/terms-and-conditions',
      name: '@Common/TermsAndConditions.vue',
      component: TermsAndConditions
    },
    {
      path: '/about',
      name: '@Common/About.vue',
      component: About
    },
    {
      path: '/links',
      name: '@Common/Links.vue',
      component: Links
    },
    {
      path: '/contact',
      name: '@Common/Contact.vue',
      component: Contact
    },
    {
      path: '/tasks',
      name: '@Administration/Tasks.vue',
      component: Tasks
    },
    {
      path: '/404',
      name: '@Common/NotFound.vue',
      component: NotFound
    },
    {
      path: '*',
      redirect: '/404'
    }
  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js